module.exports = __webpack_public_path__ + "img/shop-process.9889f963.png";